/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Bank: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <circle cx='16' cy='16' r='16' fill='#959595' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.607 9.36126C15.8481 9.21291 16.1521 9.21291 16.3931 9.36126L22.8931 13.3613C23.1789 13.5372 23.3131 13.8815 23.2217 14.2043C23.1303 14.5272 22.8356 14.7501 22.5001 14.7501H21.7501V20.7501L22.5001 20.7501C22.9143 20.7501 23.2501 21.0859 23.2501 21.5001C23.2501 21.9143 22.9143 22.2501 22.5001 22.2501L11.0001 22.25L9.50006 22.25C9.08585 22.25 8.75006 21.9142 8.75006 21.5C8.75007 21.0858 9.08585 20.75 9.50007 20.75L10.2501 20.75V14.7501H9.50006C9.16452 14.7501 8.8698 14.5272 8.77841 14.2043C8.68703 13.8815 8.82122 13.5372 9.10699 13.3613L15.607 9.36126ZM20.2501 20.7501V14.7501H16.7501V20.75L20.2501 20.7501ZM16.0001 13.25L16.0097 13.2501H19.8503L16.0001 10.8806L12.1498 13.2501H15.9904L16.0001 13.25ZM15.2501 20.75V14.7501H11.7501V20.75L15.2501 20.75Z'
      fill='white'
    />
  </React.Fragment>
)
